<template>
  <div ref="mapContainer" style="width: 100%; height: 400px;"></div>
</template>

<script>
export default {
  name: 'TMap',
  data() {
    return {
      map: null,
      geocoder: null,
      isShowDialog: false,
    };
  },
  mounted() {
    this.loadMapSDK().then(() => {
      this.initMap();
      this.geocoder = new window.qq.maps.Geocoder({
        complete: this.handleGeocodeResult.bind(this),
      });
    });
  },
  methods: {
    loadMapSDK() {
      return new Promise((resolve) => {
        if (window.qq) {
          resolve();
        } else {
          const script = document.createElement('script');
          script.src = 'https://map.qq.com/api/js?v=2.exp&key=YOUR_API_KEY';
          script.onload = () => {
            resolve();
          };
          document.head.appendChild(script);
        }
      });
    },
    initMap() {
      this.map = new window.qq.maps.Map(this.$refs.mapContainer, {
        center: new window.qq.maps.LatLng(39.916527, 116.397128),
        zoom: 12,
      });
    },
    setLocationByLatLng(lat, lng) {
      setTimeout(() => {
        this.isShowDialog = true;
        let latLng = new window.qq.maps.LatLng(lat, lng);
        console.log(latLng);
        this.geocoder.getAddress(latLng);
      }, 0); // 使用 0 延迟确保当前同步任务完成后执行
    },
    handleGeocodeResult(result) {
      if (result.status === 0) {
        console.log('Geocoding result:', result);
        // 更新 mapdata 或其他逻辑
        this.$emit('on-select', result.detail.location);
        // 你可以在这里更新父组件中的 mapdata
      } else {
        console.error('Geocoding failed:', result.message);
      }
    },
  },
};
</script>










  <style scoped lang="less">
  .search {
    margin-bottom: 15px;
    margin-top: -20px;
  }
  .address {
    margin-top: 15px;
    margin-bottom: 10px;
    .el-button {
      padding: 0;
    }
  }
  .table {
    .el-button {
      padding: 0;
    }
  }
  </style>